import { Paragraph } from '@components/atoms/Typography';
import styled from 'styled-components';

const P = styled(Paragraph)`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6e6d7a;
  font-weight: normal;
`;

const PostDate = ({ date }: { date?: string | null }) => {
  const displayDate = (date ? new Date(date) : new Date()).toLocaleDateString(
    'pt-BR',
    {
      month: 'long',
      day: '2-digit',
      year: 'numeric',
    },
  );

  return (
    <P>
      <time className="created-at">{displayDate}</time>
    </P>
  );
};

export default PostDate;
